import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button'
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import { ProcessingButton } from '../../shared/ProcessingButton';
import Spinner from 'react-bootstrap/Spinner'


const StudentDetailsModal = ({ showModal, setShowModal, editStudent, updateStudent, showOfflineModal, setShowOfflineModal, setTerm, setAmount, setDiscountAmount, allValues, setAllValues }) => {

    // const [allValues, setAllValues] = useState(editStudent);
    const [errors, setErrors] = useState({})
    const [isEdited,setIsEdited] = useState(false)
    let elementId = ""
    const updateStudentDetails = useSelector(state => state.student.updateStudentDetails)

    useEffect(() => {
        if (updateStudentDetails.status === "succeeded") {
            setShowModal(false)
        }

    }, [updateStudentDetails])


    useEffect(() => {
        setAllValues(editStudent)
        setErrors({})
    }, [editStudent])

    const focusOnError = (id) => {
        if (id) {
            document.getElementById(id).focus()
        }
    }

    const onChangeHandler = (event,key) => {
        if(event.target.value === "Paid"){
            setTerm(key)
            setShowOfflineModal(true)
            setAmount(allValues[key.replace("Status","Fee")])
            setDiscountAmount(allValues[key.replace("Status","Discounted Amount")])
        }
        setAllValues({ ...allValues, [event.target.name]: event.target.value })
    }

    const handleUpdate = () => {
        const allErrors = {}
        const changedFields = {}
        {
            Object.keys(allValues).reverse().map(key => {
                if (!allValues[key]) {
                    allErrors[key] = `${key} should not be blank`
                    elementId = key
                }

                if (key.includes("Term Fee")) {
                    if (allValues[key] != editStudent[key]) {
                        changedFields[key] = parseInt(allValues[key])
                    }
                } else {
                    if (allValues[key] !== editStudent[key]) {
                        changedFields[key] = allValues[key]
                    }
                }
            })
        }


        if (Object.keys(allErrors).length) {
            setErrors(allErrors)
            if (elementId) {
                focusOnError(elementId)
            }
        } else {
            const termFee = {}

            {
                Object.keys(changedFields).map(key => {
                    if (key.includes("Term")) {
                        let obj = {}
                        
                        let term = key.split(" ")[0]
                        let keyValue = term+" Term Fee"

                        if(!termFee[keyValue]){
                            if(changedFields[keyValue]){
                                obj.amount = changedFields[keyValue]
                            }
                            if(changedFields[term+" Term Discounted Amount"]){
                                obj.discountedAmount = changedFields[term+" Term Discounted Amount"]
                            }
                            if(changedFields[term+" Term Status"]){
                                obj.paymentStatus = changedFields[term+" Term Status"]
                            }
                            termFee[keyValue] = obj
                        }

                    }
                })
            }

            changedFields.termFeeDetails = termFee

            changedFields["ADMISSION"] = allValues.ADMISSION
            let data = changedFields
            updateStudent(data)
        }
    }


    useEffect(() => {
        for(let eachKey of Object.keys(editStudent)){
            if(editStudent[eachKey] !== allValues[eachKey]){
                setIsEdited(true)
                break
            }else{
                setIsEdited(false)
            }
        }
    },[allValues])
    

    return (
        <Modal style={{zIndex: showOfflineModal && "1"}} size="lg" show={showModal} onHide={() => { setShowModal(!showModal) }} scrollable>
            <Modal.Header closeButton>
                <Modal.Title> <p style={{padding:0, margin:0, color:"#333333", fontFamily:["Helvetica", "sans-serif"], fontSize:"20px"}}>Edit Student</p></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <div className="mrgnbtm container">
                    <form className={true ? "form-horizontal needs-validation" : "form-horizontal was-validated"} noValidate>
                        {Object.keys(editStudent).map((key,i) => {
                            return (
                                    <div key={i} className="form-group">
                                        <label className="control-label" htmlFor={key}>{key}</label>
                                        {!key.includes("Status") ?
                                            <>
                                                {key.includes("Fee")  ? 
                                                <input type="number" disabled={key === "ADMISSION"} autoComplete='off' onChange={onChangeHandler} className="form-control" defaultValue={editStudent[key]?editStudent[key]:"NA"} id={key} name={key} required />:
                                                <input disabled={key === "ADMISSION"} autoComplete='off' type="text" onChange={onChangeHandler} className="form-control" defaultValue={editStudent[key]?editStudent[key]:"NA"} id={key} name={key} required />
                                                }
                                                </> :
                                            <>
                                                <select style={{ backgroundImage: 'none' }} value={allValues[key]} onChange={(event) => {onChangeHandler(event,key)}} className="form-control" aria-label="Default select example" defaultValue={editStudent[key]} id={key} name={key}>
                                                    <option value="Paid" >Paid</option>
                                                    <option value="Unpaid">Unpaid</option>
                                                </select>
                                            </>
                                        }
                                        <div className="invalid-feedback d-block">{errors[key]}</div>
                                    </div>
                            )
                        })}
                    </form>
                </div> */}


                <div className="mrgnbtm container">
                    <form className={true ? "form-horizontal needs-validation d-flex flex-wrap" : "form-horizontal was-validated"} noValidate>
                        {Object.keys(editStudent).map((key,i) => {
                            return (
                                    <div key={i} className={key==="NAME"?"form-group w-100 pr-4 mr-4": i%2 === 0 ? "form-group w-50 pl-4":"form-group w-50 pr-4"} >
                                        <label className="control-label" htmlFor={key}>{key}</label>
                                        {!key.includes("Status") ?
                                            <>
                                                {key.includes("Fee") ? 
                                                <input type={"number"} disabled={(key === "ADMISSION") || editStudent[key.replace("Fee","Status")] === "Paid" || editStudent[key] === undefined } autoComplete='off' onChange={onChangeHandler} className="form-control" defaultValue={editStudent[key] === undefined ? 0 : editStudent[key]} id={key} name={key} required />:
                                                <input disabled={key === "ADMISSION"  || editStudent[key.replace("Discounted Amount","Status")] === "Paid" || (key.includes("Discounted Amount") && (editStudent[key] === "Pending" || editStudent[key] === "Rejected" || editStudent[key] === "NA" || editStudent[key] === undefined))} autoComplete='off' type="text" onChange={onChangeHandler} className={key==="NAME"? "form-control w-50":"form-control"} defaultValue={editStudent[key] ? (key.includes("Discounted Amount") ? editStudent[key].split(" ")[0] : editStudent[key]):"NA"} id={key} name={key} required/>
                                                }
                                                </> :
                                            <>
                                                <select style={{ backgroundImage: 'none' }} disabled={editStudent[key] === "Paid" || editStudent[key] === undefined} value={allValues[key]} onChange={(event) => {onChangeHandler(event,key)}} className="form-control" aria-label="Default select example" defaultValue={editStudent[key] === undefined ? "NA" : editStudent[key]} id={key} name={key}>
                                                   {editStudent[key] === undefined && <option>NA</option>}
                                                    <option value="Paid" >Paid</option>
                                                    <option value="Unpaid">Unpaid</option>
                                                </select>
                                            </>
                                        }
                                        <div className="invalid-feedback d-block">{errors[key]}</div>
                                    </div>
                            )
                        })}
                    </form>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {/* <Button variant="secondary" onClick={() => { setShowModal(false) }}>
                    Cancel
                </Button>
                <ProcessingButton
                    onBtnClick={handleUpdate}
                    btnText={updateStudentDetails.status === 'loading' ? 'Updating...' : 'Update'}
                    isLoading={updateStudentDetails.status === 'loading'}
                    styles="btn-color text-center mt-1 text-white"
                    variant="primary"
                /> */}

                <div style={{display:"felx", justifyContent:"center", width:"100%"}}>
                    <Button variant="light border-secondary" onClick={() => { setShowModal(false) }}>
                        Cancel
                    </Button>
                    <button onClick={handleUpdate} disabled={!isEdited} className='btn text-center ml-3 text-white' style={{backgroundColor: !isEdited ? "#dddddd" : "#0b54ab"}}>
                        {updateStudentDetails.status === 'loading' && 
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            style={{marginRight:"2px"}}/>
                        } 
                        {updateStudentDetails.status === 'loading' ? 'Updating...' : 'Update'}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default StudentDetailsModal